import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getBlackoutTargets } from "store/blackouts"
import { BLACKOUT_SCOPES } from "../constants"

/** A stable empty fallback, so callbacks keyed on the targets are not rebuilt on every render. */
const NO_TARGETS = []

/**
 * The equipment targets list — boats with their assets as `children` — which is what turns an
 * equipment blackout's asset ids into the boat ids a Review link filters by.
 *
 * Fetched once per session: `state.blackouts.targets` is shared with the settings page and the
 * create/edit form, so a surface that opens after either of them reads the list already there.
 */
export const useEquipmentTargets = ({ enabled = true } = {}) => {
  const dispatch = useDispatch()
  const targets = useSelector((state) => state.blackouts?.targets?.data?.[BLACKOUT_SCOPES.EQUIPMENT])

  const isLoaded = targets !== undefined
  useEffect(() => {
    if (!enabled || isLoaded) return
    // Without the list a Review link falls back to the listing filter, so a failure is not fatal.
    dispatch(getBlackoutTargets(BLACKOUT_SCOPES.EQUIPMENT)).catch(() => {})
  }, [dispatch, enabled, isLoaded])

  return targets || NO_TARGETS
}

export default useEquipmentTargets
